import cogoToast from 'cogo-toast';

class Toaster {
  success = (message: any) => {
    cogoToast.success(message, { position: 'top-center', heading: 'Success' });
  };

  error = (message: any) => {
    cogoToast.error(message, { heading: 'Error', hideAfter: 5, position: 'top-center' });
  };

  info = (message: any) => {
    cogoToast.info(message, { position: 'top-center', heading: 'Info' });
  };
}

export const toast = new Toaster();
